import http from '@/http'
export default {
  namespaced: true,
  state: {
    ticket: {}
  },
  mutations: {
    setTicketData(state, ticket) {
      state.ticket = ticket
    }
  },
  actions: {
    async subscription({}, paymentData) {
      try {
        const response = await http.post('/user/register/subscription', paymentData)
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    ticketData({ commit }, ticket) {
      commit('setTicketData', ticket)
    },
    async createTransaction({}, transactionData) {
      try {
        const response = await http.post('/payments/createTransaction', transactionData)
        return response.data
      } catch (err) {
        console.error(err)
      }
    }
  },
  getters: {
    ticket: state => state.ticket
  }
}
